import { Wrapper as DefaultWrapper } from "../../components/styles";
import styled from "styled-components";
import theme from "../../theme";

export const Background = styled.div`
	display: flex;
	justify-content: center;
	background-color: ${theme.color.white};
`;

export const Wrapper = styled(DefaultWrapper)`
	&&& {
		${theme.breakpoints.lg} {
			width: auto;
			grid-template-columns: repeat(12, 1fr);
		}
	}
`;

export const TextWrapper = styled.section`
	grid-column: 1 / -1;
	justify-self: center;
	width: 100%;
	margin-bottom: ${theme.gutter}px;

	${theme.breakpoints.lg} {
		grid-column: 7 / -2;
	}
`;

export const DeviceWrapper = styled.div`
	width: 275px;
	display: block;
	margin: 0 auto;
	margin-bottom: 40px;
	justify-self: center;
	position: relative;

	grid-column: 1 / 7;
	grid-row: 2 / 5;
`;

export const DownloadButtonWrapper = styled.div`
	padding-top: 5px;
	margin-bottom: 40px;
	display: flex;
	justify-content: center;

	> .only-mobile {
		display: initial;
	}
	> .only-desktop {
		display: none;
	}

	${theme.breakpoints.lg} {
		> .only-mobile {
			display: none;
		}
		> .only-desktop {
			display: initial;
		}
	}
`;

export const Subtitle = styled.h4`
	font-family: ${theme.font.family.sansSerif};
	font-weight: 600;
	font-size: 16px;
	line-height: 30px;
	color: ${theme.color.grey};
	padding-bottom: 1px;
	${({ borderless }) =>
		!borderless && `border-bottom: 1px solid ${theme.color.grey}`}
`;
